import axios from "axios";
import { basicURL } from "../../apiManager/APIConfig";
import { store } from "../store";

const UPLOADS_STORAGE_KEY = "microlab-user-upload-library";

export function getPersistedUploads() {
  try {
    const raw = sessionStorage.getItem(UPLOADS_STORAGE_KEY);
    if (!raw) return [];
    const list = JSON.parse(raw);
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function persistUploads(list) {
  try {
    sessionStorage.setItem(UPLOADS_STORAGE_KEY, JSON.stringify(list));
  } catch (e) {
    console.warn("Could not persist uploads to sessionStorage", e);
  }
}

// Fetch current user's private uploads (images/videos) – only that user's files
export const GetMyUploadsCall = async (entityType) => {
  const token = store.getState().auth?.access_token;
  if (!token) return [];
  const params = {};
  if (entityType) params.entity_type = entityType;

  try {
    const res = await axios.get(`${basicURL}file/my-uploads`, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    // Support both raw array and wrapped { data: [...] }
    let list = Array.isArray(res.data) ? res.data : [];
    if (list.length === 0 && res.data?.data && Array.isArray(res.data.data)) {
      list = res.data.data;
    }
    // Normalize: backend may return snake_case (url, etc.)
    return list.map((f) => ({
      id: f.id,
      url: f.url || f.download_url,
      name: f.name || f.alias,
      alias: f.alias || f.name,
      entity_type: f.entity_type || entityType || null,
      type: f.type || (String(f.name || "").match(/\.(mp4|webm|mov)$/i) ? "video/mp4" : "image/png"),
    }));
  } catch (error) {
    const status = error?.response?.status;
    if (status === 404 || status === 401 || status === 403) return [];
    throw error;
  }
};

// Upload a new private file bound to the current user
export const UploadMyFileCall = async (file, entityType = "user_upload") => {
  if (!file) return null;
  const token = store.getState().auth?.access_token;
  const userId = store.getState().auth?.id;
  if (!userId) throw new Error("User not authenticated");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("entity_type", entityType);
  formData.append("entity_id", userId);

  const res = await axios.post(`${basicURL}file/upload`, formData, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  return res?.data?.download_url || null;
};

// Delete one of the current user's uploads
export const DeleteMyUploadCall = async (id) => {
  if (!id) return;
  const token = store.getState().auth?.access_token;
  await axios.delete(`${basicURL}file/${id}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
};


